import type * as api from '@owl-nest/api-client/latest.ts'
import { t } from '@owl-nest/localize'

export function getLabel(platform: api.LinkServiceType): string {
  const labels = {
    bandcamp: t('Listen on Bandcamp'),
    bluesky: t('Follow us on Bluesky'),
    dailymotion: t('Watch us on Dailymotion'),
    discord: t('Join our Discord'),
    email: t('Contact us'),
    facebook: t('Like us on Facebook'),
    instagram: t('Follow us on Instagram'),
    linkedin: t('Connect on LinkedIn'),
    linktree: t('Visit our Linktree'),
    mastodon: t('Follow us on Mastodon'),
    soundcloud: t('Listen on Soundcloud'),
    spotify: t('Listen on Spotify'),
    threads: t('Follow us on Threads'),
    tiktok: t('Follow us on TikTok'),
    tumblr: t('Follow us on Tumblr'),
    twitch: t('Watch us on Twitch'),
    twitter: t('Follow us on Twitter'),
    vimeo: t('Watch us on Vimeo'),
    website: t('Visit our website'),
    youtube: t('Watch us on Youtube'),
  }

  return labels[platform]
}
